<template>
  <div class="deauth-notification-panel-content">
    <div v-if="accessErrorMessage" class="deauth-access-error">
      <div class="deauth-access-error__title">Эта настройка сейчас недоступна для вашей роли.</div>
      <div class="deauth-access-error__next-step">
        Попросите владельца проекта выдать права.
      </div>
    </div>
    <template v-else>
      <div class="tg-warn">
        <div class="tg-warn-tx">
          <span class="tg-warn-tx__desktop">
            Внимание! Для отправки необходимо запустить нашего бота
            <a
              href="https://t.me/dh_smart_bot"
              target="_blank"
              rel="noopener noreferrer"
            >@dh_smart_bot</a>.
            Как это сделать
            <HintIcon hintId="authBotTelegram" :size="14" class="tg-hint" />
          </span>
          <span class="tg-warn-tx__mobile">
            <strong>
              Запустите бота
              <a
                href="https://t.me/dh_smart_bot"
                target="_blank"
                rel="noopener noreferrer"
              >@dh_smart_bot</a>
            </strong>
            <span class="tg-warn-tx__mobile-sub">Это нужно только один раз.</span>
          </span>
        </div>
        <button
          type="button"
          class="tg-warn-btn"
          @click="openAuthBotHint"
        >
          Запустить бота
        </button>
      </div>

      <div class="tg-rows deauth-contacts-wrapper">
        <PhoneOrTgInputGroup
          :canDeleteFirstItem="true"
          :canManageContacts="canManageDeauthRecipients"
          :phoneValidator="phoneValidator"
          :value="deauthContactsValue"
          :items-meta="deauthContacts"
          :show-add-from-all-groups="isSuperUser"
          :add-from-all-groups-items="deauthAllGroups"
          color="#525AD5"
          placeholderPhone="+7 (999) 123-45-67"
          placeholderTg="Телефон / @Никнейм / ID группы"
          @input="updateDeauthContactsValue"
          @remove="removeDeauthContact"
          @verify="verifyDeauthContact"
          :verifying-indices="deauthVerifyingIndices"
          class="phone-group-input phone-group-input--starter-pack"
          appearance="starter-pack"
        />
      </div>

      <div class="tg-extra">
        <div class="tg-extra-tx">
          <span class="tg-extra-tx__desktop">
            Дополнительно отправлять уведомление о потере авторизации каналов контактам, которые получают отчёты. Напомнить, что это
          </span>
          <span class="tg-extra-tx__mobile">
            Дублировать уведомления получателям отчётов.
          </span>
          <HintIcon hintId="notificationAuthTg" :size="14" class="tg-hint tg-hint--muted" />
        </div>
        <button
          type="button"
          class="sw"
          :class="{ on: sendToReportRecipients }"
          :disabled="!canManageDeauthRecipients"
          aria-label="Вкл/выкл"
          @click="updateSendToReportRecipients(!sendToReportRecipients)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import HintIcon from '@/components/HintIcon.vue'
import PhoneOrTgInputGroup from '@/components/ui/PhoneOrTgInputGroup.vue'

export default defineComponent({
  name: 'DeauthNotificationRecipientsBlock',
  components: { HintIcon, PhoneOrTgInputGroup },
  props: {
    phoneValidator: { type: Function, required: true },
    deauthContactsValue: { type: Array, default: () => [] },
    deauthContacts: { type: Array, default: () => [] },
    deauthAllGroups: { type: Array, default: () => [] },
    accessErrorMessage: { type: String, default: '' },
    canManageDeauthRecipients: { type: Boolean, default: false },
    isSuperUser: { type: Boolean, default: false },
    updateDeauthContactsValue: { type: Function, default: () => {} },
    removeDeauthContact: { type: Function, default: () => {} },
    verifyDeauthContact: { type: Function, default: () => {} },
    /** Индексы строк с активной проверкой. */
    deauthVerifyingIndices: { type: Array, default: () => [] },
    sendToReportRecipients: { type: Boolean, default: false },
    updateSendToReportRecipients: { type: Function, default: () => {} },
  },
  methods: {
    openAuthBotHint() {
      this.$store.commit('setIsHintSidebar', true)
      this.$store.commit('setSidebarHintId', 'authBotTelegram')
    },
  },
})
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.deauth-access-error
  padding: 10px 12px
  border-radius: 8px
  border: 1px solid #e20029
  background: #fff1f4

.deauth-access-error__title
  color: #2A3B51
  font-size: 14px
  font-weight: 600

.deauth-access-error__hint
  margin-top: 4px
  color: #5c6473
  font-size: 12px

.deauth-access-error__next-step
  margin-top: 6px
  color: #2A3B51
  font-size: 12px
  font-weight: 500

.deauth-notification-panel-content
  display: flex
  flex-direction: column
  gap: 14px

  .tg-warn
    display: flex
    align-items: center
    gap: 12px
    padding: 12px 14px
    margin: 0
    border-radius: 11px
    background: #FFF7EA
    border: 1px solid #F6D69A

  .tg-warn-tx
    flex: 1
    color: #8A6212
    font-size: 12.5px
    line-height: 1.45

    a
      color: #525AD5
      font-weight: 600
      text-decoration: none

  .tg-warn-tx__mobile
    display: none

  :deep(.tg-hint)
    display: inline-flex
    vertical-align: middle
    margin-left: 4px

  :deep(.tg-hint--muted)
    opacity: 1

  .tg-warn-btn
    flex-shrink: 0
    padding: 11px 15px
    color: #fff
    font-family: Geologica, Inter, system-ui, sans-serif
    font-size: 10.5px
    font-weight: 800
    letter-spacing: .04em
    text-transform: uppercase
    background: #E08A0C
    border: none
    border-radius: 9px
    cursor: pointer
    transition: filter .15s

    &:hover
      filter: brightness(.96)

  .tg-rows
    display: flex
    flex-direction: column
    gap: 10px
    margin: 0

  .tg-extra
    display: flex
    align-items: flex-start
    gap: 14px
    padding-top: 14px
    margin: 0
    border-top: 1px solid #EFF1F6

  .tg-extra-tx
    flex: 1
    color: #1F2440
    font-size: 12.5px
    line-height: 1.5

  .tg-extra-tx__mobile
    display: none

  .sw
    width: 46px
    height: 26px
    flex-shrink: 0
    position: relative
    background: #E6E9F0
    border: none
    border-radius: 99px
    cursor: pointer
    transition: background .18s

    &::after
      content: ''
      position: absolute
      top: 2.5px
      left: 2.5px
      width: 21px
      height: 21px
      background: #fff
      border-radius: 50%
      box-shadow: 0 1px 3px rgba(26, 26, 46, .25)
      transition: transform .18s

    &.on
      background: #525AD5

      &::after
        transform: translateX(20px)

    &:disabled
      opacity: .5
      cursor: not-allowed

@media (max-width: 959px)
  .deauth-notification-panel-content
    .tg-warn
      flex-direction: column
      align-items: stretch

    .tg-warn-tx__desktop
      display: none

    .tg-warn-tx__mobile
      display: block

      strong
        display: block
        font-size: 14px
        line-height: 1.45
        color: #5F4C12
        margin-bottom: 6px

        a
          color: #525AD5
          font-weight: 800

    .tg-warn-tx__mobile-sub
      display: block
      color: #8F6A0B
      font-size: 13px
      line-height: 1.45

    .tg-warn-btn
      width: 100%
      text-align: center

    .tg-extra
      display: grid
      grid-template-columns: 1fr auto
      gap: 14px
      align-items: start
      padding-top: 2px
      border-top: none

    .tg-extra-tx
      color: #4B556D
      font-size: 13px
      line-height: 1.48

    .tg-extra-tx__desktop
      display: none

    .tg-extra-tx__mobile
      display: inline

    .sw
      width: 54px
      height: 32px
      background: #E6EAF5

      &::after
        top: 4px
        left: 4px
        width: 24px
        height: 24px
        box-shadow: 0 4px 8px rgba(0, 0, 0, .08)

      &.on
        background: #525AD5

        &::after
          transform: translateX(22px)
</style>
